import { css } from '@emotion/css';

export const titleStyles = css`
  @media (max-width: 768px) {
    padding-inline-start: 2rem;
    padding-inline-end: 2rem;
  }
`;

export const titleColorStyles = css`
  -webkit-text-fill-color: var(--text-primary); //safari color issue
`;
